import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  Button,
  Table,
  Modal,
} from "react-bootstrap";
import {
  getDepList,
  createDepartment,
  updateDepartment,
  updateDepartment2,
  getDepByID,
  resetDepartment,
  getDepZkByID
} from "./ManageDepSlice";
import { useDispatch, useSelector } from "react-redux";
import SideMenu from "../../UI/SIdeMenu";
import Navibar from "../../UI/Navibar";
import Footer from "../../UI/Footer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faEdit, faPlus } from "@fortawesome/free-solid-svg-icons";

function ManageDepComponent() {
  const dispatch = useDispatch();
  const [showAdd, setShowAdd] = useState(false);
  const [showUpdate, setShowUpdate] = useState(false);
  const [updateButton, setUpdateButton] = useState(false);
  const [searchQuery, setSearchQuery] = useState(""); // State for search query

  useEffect(() => {
    dispatch(getDepList()).then((res) => {
      console.log(res);
      console.log(res.payload);
    });
  }, []);

  const { departmentLists, department } = useSelector(
    (state) => state.ManageDepSlice
  );
  const { zkteco_department_id, description, status } = department;

  const handleCloseAdd = () => {
    setShowAdd(false);
  };
  const handleShowAdd = () => {
    setShowAdd(true);
    const entity = { ...department };
    dispatch(resetDepartment(department));
  };

  const handleCloseUpdate = () => {
    setShowUpdate(false);
  };
  const handleShowUpdate = () => {
    setShowUpdate(true);
  };
  const handleFormChange = (e) => {
    const entity = { ...department, [e.target.name]: e.target.value };
    console.log(entity);
    dispatch(updateDepartment2(entity));
  };

  // const handleCreateDepartment = (e) => {
  //   e.preventDefault();
  //   const entity = { ...department };
  //   console.log(entity);
  //   dispatch(createDepartment(entity))
  //     .then(() => {
  //       dispatch(getDepList()).then(() => {
  //         setShowAdd(false);
  //       });
  //       dispatch(resetDepartment(entity));
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // };

  const handleCreateDepartment = (e) => {
    e.preventDefault();
    const entity = { ...department };
    console.log(entity);
    dispatch(createDepartment(entity))
      .then(() => {
        dispatch(getDepList()).then(() => {
          setShowAdd(false);
          // Show success alert after successfully adding the department
          window.alert("Department added successfully!");
        });
        dispatch(resetDepartment(entity));
      })
      .catch((err) => {
        console.log(err);
      });
  };  

  const handleUpdateButton = (id) => {
    dispatch(getDepByID({id})).then(() => {
      setShowUpdate(true);
    });
    console.log(description);
  };

  // const handleUpdateDepartment = (e) => {
  //   e.preventDefault();
  //   const entity = { ...department };
  //   console.log(entity);
  //   dispatch(updateDepartment(entity))
  //     .then(() => {
  //       dispatch(getDepList()).then(() => {
  //         setShowUpdate(false);
  //         setShowAdd(false);
  //         setUpdateButton(false);
  //       });
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // };

  // const handleDeleteDepartment = (id) => {
  //   const entity = {
  //     ...department,
  //     id,
  //     status: {
  //       id: -1,
  //     },
  //   };
  //   console.log(entity);
  //   dispatch(updateDepartment(entity))
  //     .then(() => {
  //       dispatch(getDepList()).then(() => {});
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // };

  const handleUpdateDepartment = (e) => {
    e.preventDefault();
    
    const confirmUpdate = window.confirm("Are you sure you want to update this department?");
    
    if (confirmUpdate) {
      const entity = { ...department };
      console.log(entity);
      dispatch(updateDepartment(entity))
        .then(() => {
          dispatch(getDepList()).then(() => {
            setShowUpdate(false);
            setShowAdd(false);
            setUpdateButton(false);
            
            // Show success alert
            window.alert("Department updated successfully!");
          });
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };  

  const handleDeleteDepartment = (id) => {
    const confirmDelete = window.confirm("Are you sure you want to delete this department?");
    
    if (confirmDelete) {
      const entity = {
        ...department,
        id,
        status: {
          id: -1, // mark as deleted
        },
      };
      console.log(entity);
      dispatch(updateDepartment(entity))
        .then(() => {
          dispatch(getDepList()).then(() => {
            // Show success alert after successful delete
            window.alert("Department deleted successfully!");
          });
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };  
  
  const handleSearchDepartment = () => {
    if (zkteco_department_id !== "") {
      const id = parseInt(zkteco_department_id, 10);
      console.log("ID to search:", id);
  
      if (isNaN(id)) {
        console.error("Invalid ID format. Please enter a valid number.");
        return;
      }
  
      // Check if the department id already exists in departmentLists
      const departmentExists = departmentLists.some(
        entry => entry.departments?.zkteco_department_id === id
      );      

      if (departmentExists) {
        // Proceed with dispatch if the ID exists
        setUpdateButton(true);
        dispatch(getDepByID({ id }))
          .unwrap()
          .then((result) => {
              console.log(result);
              // setInputValue(result[0]?.superior?.fullname);
              
              // Construct the entity from getDepByID result
              const entity = {
                  ...department,
                  created: result.created,
                  id: result.id
              };
  
              // After updating the report, dispatch getDepZkByID
              return dispatch(getDepZkByID({ id })).unwrap().then((resultZkteco) => {
                  console.log("Dispatch Result for getDepZkByID:", resultZkteco); // Log the result after dispatch completes
                  
                  // Merge the data from getPersonZktecoById
                  const zktecoEntity = {
                      ...entity, // Include the existing entity properties
                      description: resultZkteco.data.name,
                      zkteco_department_id: resultZkteco.data.code
                  };
  
                  console.log(zktecoEntity); // Log the final entity
                  // Dispatch the combined entity
                  dispatch(updateDepartment2(zktecoEntity));
              });
          })
          .catch((err) => {
              console.error("Error in dispatch:", err);
          });
      }     
      else {
        setUpdateButton(false);
        dispatch(getDepZkByID({ id }))
        .unwrap()
        .then((result) => {
          console.log("Dispatch Result:", result); // Log the result after dispatch completes
          const entity = { ...department,
            description: result.data.name,
            zkteco_department_id: result.data.code
          };
          console.log(entity);
          dispatch(updateDepartment2(entity));
        })
        .catch((err) => {
          console.error("Error in dispatch:", err);
        });
      }
    }
  };

  // Handle the search input change
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  // Filter departments based on search query
  const filteredDepartments = departmentLists.filter(({ departments }) => {
    const { id, description } = departments;
    return (
      id.toString().includes(searchQuery) || 
      description.toLowerCase().includes(searchQuery.toLowerCase())
    );
  });

  return (
    <div className="Div">
      <Container id="sidebar-wrapper">
      <Row>
          <Col xs={12} className="fixed-top">
            <Navibar />
          </Col>
        </Row>
      </Container>
      <Container fluid>
        <Row>
          <Col
            xs={2}
            id="sidebar-wrapper"
            className="sidemenu"
            style={{ marginTop: "50px" }}
          >
            <SideMenu />
          </Col>
          <Col>
            <Card className="content">
              <Container>
                <Row className="mb-3 mt-3">
                  <Col md={12}>
                    <h4>MANAGE DEPARTMENT</h4>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md={12} style={{ textAlign: "left" }}>
                    DEPARTMENT LIST
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Col md={12}>
                    {/* Search bar */}
                    <Form.Control
                      type="text"
                      placeholder="Search by ID or Description"
                      value={searchQuery}
                      onChange={handleSearchChange}
                    />
                  </Col>
                </Row>

                <Table bordered responsive>
                  <thead>
                    <tr className="tableheader">
                      <th className="text-center">ID</th>
                      <th className="text-center">DESCRIPTION</th>
                      <th className="text-center"></th>
                      <th className="text-center"></th>
                    </tr>
                  </thead>
                  <tbody>
                    {/* {departmentLists.map(({ departments }, i) => ( */}
                    {filteredDepartments.map(({ departments }, i) => (
                      <tr key={i}>
                        <td>{departments.id}</td>
                        <td>{departments.description}</td>
                        <td>
                          <Button
                            onClick={() => handleUpdateButton(departments.id)}
                          >
                            <FontAwesomeIcon icon={faEdit} />
                          </Button>
                        </td>
                        <td>
                          <Button
                            variant="danger"
                            onClick={() =>
                              handleDeleteDepartment(departments.id)
                            }
                          >
                            <FontAwesomeIcon icon={faTrash} />
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
                <Row className="mb-3">
                  <Col md={10}></Col>
                  <Col md={2}>
                    <Button onClick={handleShowAdd}> <FontAwesomeIcon icon={faPlus}/> ADD</Button>

                    <Modal
                      show={showAdd}
                      onHide={handleCloseAdd}
                      backdrop="static"
                      keyboard={false}
                    >
                      <Modal.Header closeButton>
                        <Modal.Title>ADD DEPARTMENT</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <Form>
                          <Form.Group as={Row} className="align-items-center">
                            <Form.Label column sm={10}>ID:</Form.Label>
                            <Col sm={12} className="d-flex align-items-center">
                              <Form.Control
                                type="text"
                                name="zkteco_department_id"
                                value={zkteco_department_id}
                                onChange={handleFormChange}
                                className="mr-2" // Add right margin for spacing between input and button
                              />
                              &nbsp;&nbsp;
                              <Button onClick={handleSearchDepartment} type="button">SEARCH</Button>
                            </Col>
                          </Form.Group>
                          <Form.Group>
                            <Form.Label>DESCRIPTION:</Form.Label>
                            <Form.Control
                              type="text"
                              name="description"
                              value={description}
                              onChange={handleFormChange}
                            />
                          </Form.Group>
                        </Form>
                      </Modal.Body>
                      <Modal.Footer>
                        {updateButton == true ? (
                          <Button onClick={handleUpdateDepartment}>UPDATE</Button>
                        ) : (
                          <Button onClick={handleCreateDepartment}>SUBMIT</Button>
                        )}
                      </Modal.Footer>
                    </Modal>
                    <Modal
                      show={showUpdate}
                      onHide={handleCloseUpdate}
                      backdrop="static"
                      keyboard={false}
                    >
                      <Modal.Header closeButton>
                        <Modal.Title>EDIT DEPARTMENT</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <Form>
                          <Form.Group>
                            <Form.Label>ID:</Form.Label>
                            <Form.Control
                              type="text"
                              name="zkteco_department_id"
                              value={zkteco_department_id}
                              onChange={handleFormChange}
                            />
                          </Form.Group>
                          <Form.Group>
                            <Form.Label>DESCRIPTION:</Form.Label>
                            <Form.Control
                              type="text"
                              name="description"
                              value={description}
                              onChange={handleFormChange}
                            />
                          </Form.Group>
                        </Form>
                      </Modal.Body>
                      <Modal.Footer>
                        <Button onClick={handleUpdateDepartment}>UPDATE</Button>
                      </Modal.Footer>
                    </Modal>
                  </Col>
                </Row>
              </Container>
            </Card>
          </Col>
        </Row>
      </Container>
      <Footer />
    </div>
  );
}

export default ManageDepComponent;
